import React from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
    return (
        <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <Link className="nav-link" to="/" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Home</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/about" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>About</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/services" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Services</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/why-choose-us" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Why Choose Us</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/testimonials" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Testimonials</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/contact" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Contact</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/career" style={{color: '#f0ebebff', fontWeight: '500', padding: '0.75rem 1rem', display: 'block', textDecoration: 'none'}}>Career</Link>
            </li>
        </ul>
    );
};

export default Navigation;